import { jsxs } from "react/jsx-runtime";
import { Button } from "@contember/ui";
import { useInitIDPRedirect } from "./useInitIDPRedirect.js";
const IDPInitButton = ({ provider, onError }) => {
  const onInitIDP = useInitIDPRedirect({ onError });
  return /* @__PURE__ */ jsxs(Button, { onClick: () => onInitIDP(provider), children: [
    "Login using ",
    provider.name ?? provider.provider
  ] });
};
export {
  IDPInitButton
};
//# sourceMappingURL=IDPInitButton.js.map
